/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
export class Response {
  data: Array<any>;
  error: boolean;
  status: string;
  code: number;
  metadata: Array<any>;
}